export const presets = {
  createDefaultLayout () {
    return {
      navWidth: 240,
      navAnchor: 'left',
      navVariant: {
        xs: 'temporary',
        sm: 'permanent'
      },
      collapsible: {
        xs: false,
        sm: true
      },
      collapsedWidth: 64,
      clipped: false,
      headerPosition: 'relative',
      squeezed: false
    }
  },
  createCozyLayout: (config) => ({
    ...presets.createDefaultLayout(),
    navVariant: 'permanent',
    navWidth: 250,
    collapsible: true,
    collapsedWidth: 0,
    clipped: false,
    headerPosition: 'fixed',
    ...config
  }),
}
